import React from 'react'
import { NPaymentProviderOrderDto } from '@/api/NPayments/Types/NPaymentProviderOrderDto'
import { DataCard, DataColumn, DataGrid } from '@/components/DataCard/DataCard'
import { FormField } from '@/components/Form/FormField'
import { Button } from '@/components/ui/button'
import { ButtonGroup } from '@/components/ui/button-group'
import { NameDto } from 'api/Common/Types'
import { Form, Formik, FormikHelpers } from 'formik'
import * as Yup from 'yup'

export interface NPaymentProviderOrderingUpdateDeleteFormValues {
  methodCountryOrderId: string
  ordering: number
  userReason: string
  countryId?: string
  deviceTypeId?: number
}

interface MethodDefaultFormProps {
  v: NPaymentProviderOrderDto['methods'][0]
  onSubmit: (
    values: NPaymentProviderOrderingUpdateDeleteFormValues,
    actions: FormikHelpers<NPaymentProviderOrderingUpdateDeleteFormValues>
  ) => void
  action: 'edit' | 'delete'
  onClose: () => void
  deviceTypes: NameDto[]
  selectedDeviceType: NameDto | null
}

const validationSchema = Yup.object().shape({
  methodCountryOrderId: Yup.string().required('ID is required'),
  ordering: Yup.number()
    .integer('Order must be an integer')
    .positive('Order must be a positive number')
    .required('Order is required'),
  userReason: Yup.string().required('Reason is required'),
})

export const PaymentProviderOrderingForm: React.FC<MethodDefaultFormProps> = ({
  v,
  onSubmit,
  onClose,
  action,
  selectedDeviceType,
}) => {
  const initialValues: NPaymentProviderOrderingUpdateDeleteFormValues = {
    ordering: v.ordering,
    methodCountryOrderId: v.id,
    userReason: '',
    countryId: v.country?.id,
    deviceTypeId: v.deviceType?.id || selectedDeviceType?.id,
  }

  return (
    <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
      {({ errors, touched, isSubmitting, resetForm }) => (
        <Form>
          <DataGrid
            columns={1}
            rightAddon={
              <ButtonGroup>
                <Button
                  variant='outline'
                  type='button'
                  onClick={() => {
                    onClose()
                    resetForm()
                  }}
                >
                  Cancel
                </Button>
                <Button disabled={isSubmitting} type='submit'>
                  Save
                </Button>
              </ButtonGroup>
            }
          >
            <DataColumn>
              <DataCard title={action === 'edit' ? 'Edit method order' : 'Confirm delete'}>
                {action === 'edit' && (
                  <FormField
                    type='number'
                    name='ordering'
                    label='Order'
                    error={touched.ordering ? errors.ordering : undefined}
                    dataTest='ordering-data-field'
                  />
                )}
                <FormField
                  type='text'
                  name='userReason'
                  label='Reason'
                  error={touched.userReason ? errors.userReason : undefined}
                  dataTest='userReason-data-field'
                />
              </DataCard>
            </DataColumn>
          </DataGrid>
        </Form>
      )}
    </Formik>
  )
}
